module.exports = __webpack_public_path__ + "static/media/team-swimmy-thibaut.58fcaaf6.png";